import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Link, SidebarModal } from '@domain-group/suit-theme'

import useUser from '@hooks/useUser'

interface UserListItemProps {
  callbacks: {
      removeAgentUsers: () => void,
  },
  userId: number,
}

const UserListItem = (props: UserListItemProps) => {
  const {
    callbacks: { removeAgentUsers }, userId,
  } = props

  const userPayload = useUser({ id: userId })

  const {
    image,
    user,
  } = userPayload

  const {
    full_name, id, mobile_number,
  } = user

  return (
    <SidebarModal.User
      disableHover
      // @ts-expect-error TS2339
      imageUrl={image?.square_url}
      key={id}
      subtitle={mobile_number || 'No Mobile'}
      title={full_name || 'Deleted User'}
    >
      <Link
        greyLink
        onClick={() => removeAgentUsers()}
        textProps={{ fontSize: 'small' }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </SidebarModal.User>
  )
}

export default UserListItem
